/**
 * Shared layout constants for responsive design.
 * Aligned with Tailwind CSS 4.0 and mobile-first strategy.
 */

export const LAYOUT = {
  TOUCH_TARGET_SIZE: '44px',
  SAFE_AREA_PADDING: 'env(safe-area-inset-bottom, 16px)',
  MODAL_ROUNDED: 'rounded-2xl',
  // PRIMARY_BLUE was here, an unused #2563eb that matched no token and no other
  // colour in the product. Colour belongs in the @theme block of index.css.
  
  BREAKPOINTS: {
    MOBILE: 375,
    TABLET: 768,
    DESKTOP: 1024,
  },
  
  NAV_HEIGHT: {
    BOTTOM_BAR: '64px',
    SIDEBAR_WIDTH: '260px',
  }
};
